export default __webpack_public_path__ + "static/media/BLF_logo.016e3f55.png";